import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './store';
import dayjs from 'dayjs';
import App from './app';
import { TokenProvider } from './hooks/useToken';

import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import duration from 'dayjs/plugin/duration';

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(duration);

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
	<Provider store={store}>
		<Router>
			<TokenProvider>
				<App />
			</TokenProvider>
		</Router>
	</Provider>
);
